export default __webpack_public_path__ + "static/media/2017_Letten_et_al_2017_EcologicalMonographs.ea763aca.pdf";